// flow weak

import React, {
  PureComponent
}                         from 'react';
import PropTypes          from 'prop-types';
import {
  AnimatedView,
  StatsTable,
  MaterialList
}                         from '../../../components';
import styles                 from './style';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../services/fetchTools';
import {Link} from 'react-router-dom';
import FlatButton from 'material-ui/FlatButton';
import styled from 'styled-components';
import { Spinner } from 'react-activity';
import Dialog from 'material-ui/Dialog';
import moment from 'moment';
import DatePicker from 'react-datepicker';

class ReportsInfo extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      venue : this.props.venue,
      monthly_data: [],
      weekly_data: [],
      daily_data: [],
      start_date:moment(),
      end_date:moment(),
      daily: true,
      weekly: false,
      monthly: false,
      loading: false,
      date_changed: false
    };
    this.handleSelection = this.handleSelection.bind(this);
    this.handleStartDate = this.handleStartDate.bind(this);
    this.handleEndDate = this.handleEndDate.bind(this);
    
  }

  componentWillMount() {
    const { actions: { enterPage } } = this.props;
    enterPage('Home');
  }

  componentDidMount() {
  }

  componentWillUnmount() {
    const { actions: { leavePage } } = this.props;
    leavePage('Home');
  }

  getMonthlyRevenue() {
    const url = `${getLocationOrigin()}/eagleeye/getTableDataJSON/?report_id=71003&venue_id=${this.state.venue}`;
    const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
            this.setState({monthly_data:data.data,loading:false})
           // alert("fix");
       }).catch(error => error);
  }

  getWeeklyRevenue() {
    const url = `${getLocationOrigin()}/eagleeye/getTableDataJSON/?report_id=71002&venue_id=${this.state.venue}`;
    const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
            this.setState({weekly_data:data.data,loading:false})
           // alert("fix");
       }).catch(error => error);
  }

  getDailyRevenue() {
    var start = moment(this.state.start_date).format("YYYY-MM-DD")
    var end = moment(this.state.end_date).format("YYYY-MM-DD")

    const url = `${getLocationOrigin()}/eagleeye/getTableDataJSON/?report_id=71001&venue_id=${this.state.venue}&date=${start}&end_date=${end}`;
    const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
            this.setState({daily_data:data.data,loading:false,date_changed:false})
           // alert("fix");
       }).catch(error => error);
  }

  handleSelection(event){
    const name = event.target.name
    if(name == 'daily'){
      this.setState({daily:true,weekly:false,monthly:false})
    }
    else if(name == 'weekly'){
      this.setState({weekly:true,daily:false,monthly:false})
    }
    else if(name == 'monthly'){
      this.setState({monthly:true,daily:false,weekly:false})
    }
  }

  handleStartDate(date) {
    this.setState({start_date:date,date_changed:true})
    this.renderDailyRevenue()
  }

  handleEndDate(date) {
    this.setState({end_date:date,date_changed:true})
    this.renderDailyRevenue()
  }

  renderMonthlyRevenue(){
    if(this.state.monthly_data.length == 0){
      this.getMonthlyRevenue()
    }
    var yearly_header = []
    if(this.state.monthly_data.length > 0){
      yearly_header = Object.keys(this.state.monthly_data[0])
      console.log('yearly_header',yearly_header)
    }
    return(
      <div className='col-md-12 table_container1' style={styles.table}>
        <div className="heading heading2 left" style={styles.header}>Monthly Revenue</div> 
        <table className="table_plain">
          <tr> 
            { yearly_header && yearly_header.length > 0 &&
              yearly_header.map((header)=>
                <th>{header}</th>
                )
             }
          </tr>
          
            { this.state.monthly_data && this.state.monthly_data.length > 0 ?
              this.state.monthly_data.map((data)=>
                <tr>
                 { Object.keys(data).map((index)=>
                    <td>{data[index]}</td>
                    )
                  }
                </tr>
                )
              :
              <div style={{height:500}}>
                <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}> <Spinner size="50" /></div>
              </div>
            }
        </table>
      </div>
      )
  }

  renderWeeklyRevenue(){
    if(this.state.weekly_data.length == 0){
      this.getWeeklyRevenue()
    }
    var weekly_header = []
    if(this.state.weekly_data.length > 0){
      weekly_header = Object.keys(this.state.weekly_data[0])
      console.log('weekly_header',weekly_header)
    }
    return(
      <div className='col-md-12 table_container1' style={styles.table}>
        <div className="heading heading2 left" style={styles.header}>Weekly Revenue</div> 
        <table className="table_plain">
          <tr> 
            { weekly_header && weekly_header.length > 0 &&
              weekly_header.map((header)=>
                <th>{header}</th>
                )
             }
          </tr>
          
            { this.state.weekly_data && this.state.weekly_data.length > 0 ?
              this.state.weekly_data.map((data)=>
                <tr>
                 { Object.keys(data).map((index)=>
                    <td>{data[index]}</td>
                    )
                  }
                </tr>
                )
              :
              <div style={{height:500}}>
                <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}> <Spinner size="50" /></div>
              </div>
            }
        </table>
      </div>
      )
  }

  renderDailyRevenue(){
    if(this.state.daily_data.length == 0 || this.state.date_changed){
      this.getDailyRevenue()
    }
    var daily_header = []
    if(this.state.daily_data.length > 0){
      daily_header = Object.keys(this.state.daily_data[0])
      console.log('daily_header',daily_header)
    }
    return(
      <div className='col-md-12' style={styles.table}>
        <div className='col-md-6' style={styles.date}>
          <div className='col-md-3' style={{padding:'0px',marginRight:'20%'}}>
            <div style={{fontWeight:'bold'}}> From - </div>
            <DatePicker selected={this.state.start_date} onChange={this.handleStartDate} style={{marginRight:'3%'}}/>
          </div>
          <div className='col-md-3' style={{padding:'0px'}}>
            <div style={{fontWeight:'bold'}}> To - </div>
            <DatePicker selected={this.state.end_date} onChange={this.handleEndDate}/>
          </div>
        </div>

        <div className='col-md-12 table_container1'>
          <div className="heading heading2 left" style={styles.header}>Daily Revenue</div> 
          <table className="table_plain">
            <tr> 
              { daily_header && daily_header.length > 0 &&
                daily_header.map((header)=>
                  <th>{header}</th>
                  )
               }
            </tr>
            
            { this.state.daily_data && this.state.daily_data.length > 0 && !this.state.date_changed?
              this.state.daily_data.map((data)=>
                <tr>
                 { Object.keys(data).map((index)=>
                    <td>{data[index]}</td>
                    )
                  }
                </tr>
                )
              :
              <div style={{height:500}}>
                <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}> <Spinner size="50" /></div>
              </div>
            }
          </table>
        </div>
      </div>
      )
  }
  
  render() {
    console.log('yearly_data',this.state.monthly_data)
    
    return(
      <div style={styles.container}>
        
          <div className='col-md-12'>
            <div className='col-md-12' style={{padding:'0px'}}>
              <button className='button1' style={{marginRight:'1%'}} name='daily' onClick={this.handleSelection}> Daily Revenue </button>
              <button className='button1' style={{marginRight:'1%'}} name='weekly' onClick={this.handleSelection}> Weekly Revenue </button>
              <button className='button1' style={{marginRight:'1%'}} name='monthly' onClick={this.handleSelection}> Monthly Revenue </button>
            </div>
              { this.state.daily &&
                this.renderDailyRevenue()
              }

              { this.state.weekly &&
                this.renderWeeklyRevenue()
              }

              { this.state.monthly &&
                this.renderMonthlyRevenue()
              }
            
          </div>
        
      </div>
    );
  }
}

export default ReportsInfo;



// WEBPACK FOOTER //
// ./src/app/views/centerportal/ReportsInfo/ReportsInfo.js